<template>
    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Brand Configuration</v-toolbar-title>
            <v-toolbar-title v-else>Edit Brand Configuration - {{selectedItem.name}}</v-toolbar-title>
            <v-spacer/>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <!--BRAND CONFIGURATION-->
                <v-tab>BRAND CONFIGURATION</v-tab>

                <!--CI CONFIGURATION FOR BRBAND-->
                <v-tab :disabled="tabsDisabled">CI</v-tab>

                <!--BRAND BRANCH OFFICES-->
                <v-tab :disabled="tabsDisabled">BRANCH OFFICES</v-tab>

                <!--BRAND MAIL SETTINGS-->
                <v-tab :disabled="tabsDisabled">MAIL SETTINGS</v-tab>

              <!--BRAND SHOPIFY SETTINGS-->
              <v-tab :disabled="tabsDisabled">SHOPIFY SETTINGS</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless">
            <v-tab-item>

                <v-layout v-if="dialog && activeTab === 0" wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Brand Configuration
                                        <v-spacer/>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Brand Configuration</v-subheader>
                                            <v-divider/>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field v-show="!getInitialLoading"
                                                          v-model="selectedItem.name"
                                                          label="Brand Name"
                                                          data-vv-name="name"
                                                          required
                                                          height="52"
                                            />

                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCIs"
                                                            label="Brand CI"
                                                            v-model="selectedItem.brand_configurations_ci_id"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-switch v-show="!getInitialLoading"
                                                      color="secondary" label="Default"
                                                      v-model="selectedItem.default"/>

                                        </v-flex>

                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer/>
                                            <v-btn :loading="loading" dark color="secondary"
                                                   @click.native="saveAndGoToNextTab(1)">
                                                Save and clear cache
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                        </v-flex>

                        <v-layout mt-5 row justify-end>

                        </v-layout>

                    </v-container>
                </v-layout>
            </v-tab-item>

            <v-tab-item>
                <brandConfigurationCI/>
            </v-tab-item>
            <v-tab-item>
                <brandConfigurationBranchOffices/>
            </v-tab-item>
            <v-tab-item>
                <brandConfigurationMailSettings/>
            </v-tab-item>
          <v-tab-item>
            <brandConfigurationShopifySettings/>
          </v-tab-item>

        </v-tabs-items>

    </v-card>
</template>

<script>
import {
  Settings,
  BrandConfiguration,
  BrandConfigurationCI
} from '../../store/namespace-helper'

import FakeItem from '../Shared/FakeItem.vue'
import FakeTable from '../Shared/FakeTable.vue'
import brandConfigurationCI from '../Settings/BrandConfiguration/BrandConfigurationCI'
import brandConfigurationBranchOffices from '../Settings/BrandConfiguration/BrandConfigurationBranchOffices'
import brandConfigurationMailSettings from '../Settings/BrandConfiguration/BrandConfigurationMailSettings'
import brandConfigurationShopifySettings from '../Settings/BrandConfiguration/BrandConfigurationShopifySettings'

import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

export default {
  name: 'add-brand-configuration',
  mixins: [initialLoadingMixin],
  components: {
    FakeItem,
    FakeTable,
    brandConfigurationCI,
    brandConfigurationBranchOffices,
    brandConfigurationMailSettings,
    brandConfigurationShopifySettings
  },
  data () {
    return {
      touchless: true,
      activeTab: 0,
      isVisible: false,
      onDismissed: false
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadCIs()
          this.initialLoadingTimeout(850)
        } else {

        }
      }
    },
    closeDialog () {
      this.$store.dispatch(BrandConfiguration.actions.setSelectedBrandConfiguration, null)
      this.$store.dispatch(BrandConfiguration.actions.openCloseDialog)
    },
    saveAndGoToNextTab (index) {
      this.$store.dispatch(BrandConfiguration.actions.saveBrandConfiguration, this.selectedItem).then(response => {
        this.activeTab = index
      })
    },
    openBottomSheet (payload) {
      if (payload) {
        this.$store.dispatch('openCloseBottomSheet')
      }
    },
    loadCIs: function () {
      this.$store.dispatch(BrandConfigurationCI.actions.loadBrandConfigurationCIs)
    }

  },
  computed: {
    dialog () {
      return this.$store.getters[BrandConfiguration.getters.getOpenDialogState]
    },
    selectedItem () {
      return this.$store.getters[BrandConfiguration.getters.getSelectedBrandConfiguration]
    },
    getCIs () {
      return this.$store.getters[BrandConfigurationCI.getters.brandConfigurationCIs]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    formEdited () {
      return this.formUpdated < 1
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    cardTitle () {
      if (this.selectedItem.id === 0) {
        return 'Add new'
      } else {
        return 'Edit'
      }
    },
    tabsDisabled () {
      return this.$store.getters[BrandConfiguration.getters.getSelectedBrandConfiguration].id === 0
    }

  },
  watch: {}
}
</script>

<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddBrandConfigration.vue